import React, { useState } from 'react'
import {
	ADIcon,
	AlertIcon,
	CircularCrossIcon,
	EmptyBigBoxIcon,
	PlusIcon,
	RightArrowIcon,
	ThreeDotsIcon,
} from '../icons'

//tippy
import Tippy from '@tippyjs/react'
import { Modal } from '../util'

interface DataI {
	imgURL?: string
	name?: string
	date?: string
	noOfProjects: number
}
// interface BrandsListsPropsI {
// 	data: DataI[]
// }

export const ProjectsLists: React.FC = () => {
	//local states
	const [open, setOpen] = useState<boolean>(false)
	const [data] = useState<DataI[]>(dataSet)
	return (
		<div className='brandslists'>
			<div className='rows'>
				<div className='first-row'>
					<section className='content'>
						<h1>Brand Projects</h1>
						<p>
							See your projects and create new ones under the selected brand.
						</p>
					</section>
					{data.length !== 0 && (
						<section className='select-section'>
							<select>
								<option>ABDENYOUN</option>
								<option>Ping Pong</option>
								<option>Ting Tong</option>
							</select>
							<div>
								<ADIcon />
							</div>
						</section>
					)}
				</div>
				<div className='second-row'>
					<section className='lists-nav-bar'>
						<h1>Projects under [Project Name]</h1>
						<section className='button-section'>
							<button>
								CREATE A PROJECT <RightArrowIcon />
							</button>
						</section>
					</section>
					{data.length !== 0 ? (
						<section className='cards-grid'>
							{data.map((item, i) => {
								return (
									<section key={i} className='card'>
										<section className='content'>
											<img src={item.imgURL} alt='tag' />
											<div className='text'>
												<h3>{item.name}</h3>
												<p>{item.noOfProjects} Posts Downloaded</p>
												<p>{item.date}</p>
											</div>
										</section>
										<section className='button-section'>
											<Tippy
												interactive={true}
												placement={'bottom'}
												content={
													<button
														className='delete-button'
														onClick={() => setOpen(true)}>
														<CircularCrossIcon /> Delete
													</button>
												}>
												<button className='threedotsicon-button'>
													<ThreeDotsIcon />
												</button>
											</Tippy>
										</section>
									</section>
								)
							})}
							<Modal open={open} onClick={() => setOpen(false)}>
								<section className='delete-modal-popup-content'>
									<AlertIcon />
									<h1>Delete Brand</h1>
									<small>
										You are deleting your brand: ADYOUNEED This action cannot be
										undone. Your projects created within the brand will also be
										deleted.
									</small>
									<section className='button-section'>
										<button>
											I’m sure, delete the brand <RightArrowIcon />
										</button>
									</section>
								</section>
							</Modal>
						</section>
					) : (
						<section className='when-data-is-null'>
							<section className='button-section'>
								<button>
									<PlusIcon />
									Create a new BRAND
								</button>
								{/* </section>
						<section className='footer-section'> */}
								<p>
									No brand has been created yet. Click the button above to
									create a new brand.
								</p>
							</section>
							<section className='box-svg-section'>
								<EmptyBigBoxIcon />
							</section>
						</section>
					)}
				</div>
			</div>
		</div>
	)
}

const dataSet = [
	{
		imgURL: './logo192.png',
		name: 'GrowthYouNeed',
		date: '21.4.2014',
		noOfProjects: 4,
	},
	{
		imgURL: './logo192.png',
		name: 'GrowthYouNeed',
		date: '21.4.2014',
		noOfProjects: 4,
	},
	{
		imgURL: './logo192.png',
		name: 'GrowthYouNeed',
		date: '21.4.2014',
		noOfProjects: 4,
	},
	{
		imgURL: './logo192.png',
		name: 'GrowthYouNeed',
		date: '21.4.2014',
		noOfProjects: 4,
	},
	{
		imgURL: './logo192.png',
		name: 'GrowthYouNeed',
		date: '21.4.2014',
		noOfProjects: 4,
	},
	{
		imgURL: './logo192.png',
		name: 'GrowthYouNeed',
		date: '21.4.2014',
		noOfProjects: 4,
	},
	{
		imgURL: './logo192.png',
		name: 'GrowthYouNeed',
		date: '21.4.2014',
		noOfProjects: 4,
	},
]
